"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var RangeContext = React.createContext({});
var _default = RangeContext;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-picker/lib/RangeContext.js
// module id = 65
// module chunks = 0